import { ILogEntry } from "motw_core/Entity/ILogEntry";
import * as React from "react";

export function DisplayLogEntryText(row: ILogEntry) {
    const displayText = row.entry
        .split(/\s+/)
        .slice(2)
        .join(" ")
        .replace(/\s+\d+$/, "");

    return (
        <span
            style={{
                alignItems: `center`,
                display: `flex`,
                minWidth: 0,
                overflow: `hidden`,
                padding: `0 16px 0 12px`,
                textOverflow: `ellipsis`,
                textAlign: `left`,
                fontSize: `103%`,
                lineHeight: `1`,
                textShadow: `0 1px 2px rgba(0, 0, 0, 0.55)`,
                whiteSpace: `nowrap`,
            }}
            onBlur={(event) => {
                throw new Error("TODO: Get this working again!");
                // HandleDataChanged(event, data, row, ELogEntry.entry);
            }}
            suppressContentEditableWarning
        >
            {displayText}
        </span>
    );
}
